import SocialLoginButton from './SocialLoginButton.react'

export default SocialLoginButton